import api from './api';
import { GET, POST, enochRoutes } from '../constants/api';

export const getEnochGeneralReport = ({
  email,
  ipAddress,
  fromDate,
  toDate,
  profile,
} = {}) =>
  api({
    method: GET,
    url: enochRoutes.GET_GENERAL_REPORT,
    params: { email, ipAddress, fromDate, toDate, profile },
  });

export const getEnochProfileConnectionStats = ({
  email,
  ipAddress,
  profile,
} = {}) =>
  api({
    method: GET,
    url: enochRoutes.GET_ENOCH_PROFILE_CONNECTION_STATS,
    params: { email, ipAddress, profile },
  });

export const getEnochHistogramReport = ({
  email,
  ipAddress,
  fromDate,
  toDate,
  profile,
} = {}) =>
  api({
    method: GET,
    url: enochRoutes.GET_HISTOGRAM_REPORT,
    params: { email, ipAddress, fromDate, toDate, profile },
  });

export const getAllEnochMachineIps = () =>
  api({
    method: GET,
    url: enochRoutes.GET_ALL_MACHINE_IPS,
  });

export const getAllEnochEmails = ipAddress =>
  api({
    method: GET,
    url: enochRoutes.GET_ALL_EMAILS,
    params: { ipAddress },
  });

export const getEnochConfig = ipAddress =>
  api({
    method: GET,
    url: enochRoutes.GET_ENOCH_CONFIG(ipAddress),
  });

export const getProfilesOfVM = ipAddress =>
  api({
    method: GET,
    url: enochRoutes.GET_PROFILES_OF_VM(ipAddress),
  });

export const getEnochReportHistory = ({
  email,
  ipAddress,
  fromDate,
  toDate,
  profile,
  cursor,
  limit,
}) =>
  api({
    method: GET,
    url: enochRoutes.GET_ENOCH_REPORT_HISTORY,
    params: { email, ipAddress, fromDate, toDate, profile, cursor, limit },
  });

export const getEnochReportHistoryByVM = ({
  email,
  ipAddress,
  profile,
  cursor,
  limit,
}) =>
  api({
    method: GET,
    url: enochRoutes.GET_ENOCH_REPORT_HISTORY_BY_VM,
    params: { email, ipAddress, profile, cursor, limit },
  });

export const getEnochProfileDetails = ({
  email,
  ipAddress,
  profile,
  cursor,
  limit,
}) =>
  api({
    method: GET,
    url: enochRoutes.GET_ENOCH_PROFILE_DETAILS,
    params: { email, ipAddress, profile, cursor, limit },
  });

export const getEnochReportLogsHistory = ({ reportId, cursor, limit }) =>
  api({
    method: GET,
    url: enochRoutes.GET_ENOCH_REPORT_LOGS_HISTORY.replace(
      ':reportId',
      reportId,
    ),
    params: { cursor, limit },
  });

export const saveEnochConfig = ({
  ipAddress,
  config,
  userDataDir,
  useDefaultConfig,
}) =>
  api({
    method: POST,
    url: enochRoutes.SAVE_ENOCH_CONFIG(ipAddress),
    data: {
      config,
      user_data_dir: userDataDir,
      use_default_config: useDefaultConfig,
    },
  });

export const terminateEnochJob = ({ ipAddress }) =>
  api({
    method: POST,
    url: enochRoutes.TERMINATE_ENOCH_JOB(ipAddress),
  });

export const runEnochJob = ({ ipAddress }) =>
  api({
    method: POST,
    url: enochRoutes.RUN_ENOCH_JOB(ipAddress),
  });

export const getIdleEnochVMs = () =>
  api({
    method: GET,
    url: enochRoutes.GET_IDLE_ENOCH_VMS,
  });

export const getRunningEnochVMs = () =>
  api({
    method: GET,
    url: enochRoutes.GET_RUNNING_ENOCH_VMS,
  });
